// COOKIES
export const PREV_URL_COOKIE = 'PREV_URL';
